import { render, staticRenderFns } from "./RegisteredProductsAdd.vue?vue&type=template&id=6889f642"
import script from "./RegisteredProductsAdd.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports